/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import React, { Component } from "react";
import { Route } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { LoadingContext } from "../context/LoadingContext";

export default class RouteWithAccessKeys extends Component {
  state = {
    accessKeys: {},
    setAccessKeys: accessKeys => this.setState({ accessKeys })
  };

  render() {
    const { path, render } = this.props;
    return (
      <LoadingContext.Consumer>
        {({ loading }) => {
          const isLoading = loading !== 0;
          return (
            <>
              {isLoading && (
                <div className="spinner-container">
                  <Spinner className="spinner" animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              )}
              {<Route path={path} render={render} />}
            </>
          );
        }}
      </LoadingContext.Consumer>
    );
  }
}
